import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { provideUploadApi, UPLOAD_API } from '../../../../api/services/upload.api';
import { NOTIFICATION_SERVICE } from '../../../../shared/notification/notification';
import { DocumentFile } from '../../../../api/app-types/document.app';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';

@Component({
	selector: 'lvr-document-delete-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	template: `
		<h2 mat-dialog-title>{{ 'client.documents.delete.title' | transloco }}</h2>
		<mat-dialog-content>
			<p>{{ 'client.documents.delete.confirmation' | transloco }}</p>
		</mat-dialog-content>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				mat-dialog-close
				icon="disabled_by_default"
			>
			</lvr-button>
			<lvr-button
				variant="primary"
				[label]="'base.button.delete' | transloco"
				[loadingLabel]="'base.button.deleting' | transloco"
				[type]="'button'"
				[loading]="loading()"
				(clicked)="deleteDocument()"
				icon="delete"
			>
			</lvr-button>
		</mat-dialog-actions>
	`,
	providers: [provideUploadApi],
})
export class LvrDocumentDeleteDialog {
	private readonly api = inject(UPLOAD_API);
	private readonly dialogRef = inject(MatDialogRef<LvrDocumentDeleteDialog>);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly data: { document: DocumentFile } = inject(MAT_DIALOG_DATA);
	public readonly document = this.data.document;
	public readonly loading = signal(false);

	public async deleteDocument() {
		this.loading.set(true);

		try {
			await this.api.deleteDocument(this.document.id);
			this.ntfySrv.addNotification(createSuccessNotification('Dokument wurde erfolgreich gelöscht'));
			this.dialogRef.close(true);
		} catch {
			this.ntfySrv.addNotification(createErrorNotification('Fehler bei der Löschung des Dokument'));
		} finally {
			this.loading.set(false);
		}
	}
}
